import { TLang } from 'src/constants/langs'

import DataRo from 'src/icons/data-ro.webp'
import DataDe from 'src/icons/data-de.webp'
import DataEs from 'src/icons/data-es.webp'
import DataEn from 'src/icons/data-en.webp'
import DataFr from 'src/icons/data-fr.webp'
import DataIt from 'src/icons/data-it.webp'
import DataPt from 'src/icons/data-pt.webp'
import DataEl from 'src/icons/data-el.webp'
import DataSl from 'src/icons/data-sl.webp'

interface ITextBtn {
    lang: TLang
    text: string
}

export const textBtn: ITextBtn[] = [
    {
        lang: 'ro',
        text: 'А ÎNVÂRTI',
    },
    {
        lang: 'de',
        text: 'DREH',
    },
    {
        lang: 'es',
        text: 'GIRO',
    },
    {
        lang: 'en',
        text: 'SPIN',
    },
    {
        lang: 'fr',
        text: 'TOUR',
    },
    {
        lang: 'it',
        text: 'GIRO',
    },
    {
        lang: 'pt',
        text: 'GIRO',
    },
    {
        lang: 'el',
        text: 'Περιστροφή',
    },
    {
        lang: 'sl',
        text: 'ZAVRTI',
    },
]

export const imageDataMap: Record<TLang, string> = {
    ro: DataRo,
    de: DataDe,
    es: DataEs,
    en: DataEn,
    fr: DataFr,
    it: DataIt,
    pt: DataPt,
    el: DataEl,
    sl: DataSl,
}
